import React from "react";
import clientConfig from "../../client-config";
import WCUItem from "./wcuItem";
import * as styles from './whyChooseUs.module.css';

function WhyChooseUs(props) {
    
    let bgColor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';
    let bgcolorbot = (props.bgcolorbot) ? props.bgcolorbot.hex : '#FFFFFF';

    return (
        <div className={styles.sectionWhyChooseUs} style={{ backgroundColor: `${bgColor}`}}>
            <div className={styles.sectionContainer}>
                <h3>{props.heading}</h3>
                <div className={styles.listWrapper}>

                    {
                        props.items.map((item, i) => {  
                            return <WCUItem item={item} key={i} />
                        })
                    }

                </div>
            </div>
            
            <div className={styles.sectionBottomBackground} style={{ backgroundColor: `${bgcolorbot}`}}></div>
            
        </div>
    );
}
  
export default WhyChooseUs;